<template>
	<el-dialog
		:title="$t('password.title')"
		:visible.sync="dialogPassword"
		width="40%"
		@closed="closePwdDialog"
		top="9vh"
		:modal-append-to-body="true"
		:append-to-body="true">
		<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
			<el-form
				:model="passwordModel"
				:rules="rules"
				ref="passwordModel"
				label-width="100px"
				:label-position="labelPosition"
				class="demo-ruleForm">
				<el-form-item :label="$t('password.oldPassword')" prop="oldPassword">
					<el-input
						type="password"
						v-model="passwordModel.oldPassword"
						autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('password.password')" prop="passWord">
					<el-input
						type="password"
						v-model="passwordModel.passWord"
						autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item
					:label="$t('password.checkPassword')"
					prop="checkPassword">
					<el-input
						type="password"
						v-model="passwordModel.checkPassword"
						autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="passwordDialog">{{ $t("common.cancel") }}</el-button>
			<el-button
				type="primary"
				:disabled="loadingForm"
				@click="submitForm('passwordModel')"
				>{{ $t("common.definite") }}</el-button
			>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "Password",
	data() {
		let validatePass = (rule, value, callback) => {
			if (value === "") {
				callback(new Error(this.$t("password.pPassword")));
			} else {
				if (this.passwordModel.checkPassword !== "") {
					this.$refs.passwordModel.validateField("checkPassword");
				}
				callback();
			}
		};
		let validateCheckPass = (rule, value, callback) => {
			if (value === "") {
				callback(new Error(this.$t("password.pCheckPassword")));
			} else if (value !== this.passwordModel.passWord) {
				callback(new Error(this.$t("password.vPassword")));
			} else {
				callback();
			}
		};
		return {
			passwordModel: {
				oldPassword: "",
				passWord: "",
				checkPassword: "",
			},
			loadingForm: false,
			oldPassword: "",
			rules: {
				oldPassword: [
					{
						min: 3,
						max: 16,
						message: this.$t("password.vLen"),
						trigger: "blur",
					},
					{ required: true },
				],
				passWord: [
					{ validator: validatePass, trigger: "blur" },
					{
						min: 6,
						max: 16,
						message: this.$t("password.vLen"),
						trigger: "blur",
					},
					{ required: true },
				],
				checkPassword: [
					{ validator: validateCheckPass, trigger: "blur" },
					{
						min: 6,
						max: 16,
						message: this.$t("password.vLen"),
						trigger: "blur",
					},
					{ required: true },
				],
			},
			labelPosition: "top",
		};
	},
	props: {
		dialogPassword: Boolean,
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let obj = {};
					Object.keys(this.passwordModel).forEach(key => {
						obj[key] = this.$md5(this.passwordModel[key]);
					});
					this.$api
						.request(this.$url.User.updatePassword, this.$method.put, obj)
						.then(res => {
							if (res.code === 0) {
								this.passwordDialog();
								this.$alert(
									this.$t("password.success"),
									this.$t("common.tip"),
									{
										confirmButtonText: this.$t("common.definite"),
										showClose: false,
										callback: () => {
											this.$store.dispatch("loginOut");
											this.$router.push("/login");
										},
									}
								);
							} else {
								this.$message.error(res.msg);
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				}
			});
		},
		passwordDialog() {
			this.$emit("closePasswordDialog", false);
		},
		closePwdDialog() {
			this.$emit("closePasswordDialog", false);
		},
	},
};
</script>

<style scoped></style>
